import { ManageElement } from "./ManageElement";
import { SpecieStore } from "stores/SpecieStore";

export class Specie extends ManageElement {
  static _store: SpecieStore;
}
